import { api } from "./index"
import { BaseResponseType, IEmployee, IEquipment, IServiceOrderShort, IUser } from "../../types/content"
import { IServiceOrder, IServiceOrderWithReview, TDirectory } from "../../types/orderTypes"

// @ts-ignore
export const contentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    // категории сервисов - Напитки, Уборка, Климат контроль
    // сервисы - Черный чай, Пицца, Минеральная вода
    //Категории(Напитки, Климат контроль) => Подкатегории(Чай, вода, кофе - у категории Напитки, к примеру) => сами уже услуги(черный чай, зелёный чай)

    //создать заявку
    // service_id - required, id услуги
    // count - количество
    // technical_object_id - id объекта, где должна быть оказана услуга. required - если у услуги есть список объектов, иначе игнорируем
    // options - массив выбранных опций
    //    возможные варианты type(не нужно передавать)
    //      text - текстовое поле
    //      number - числовое поле
    //      checkbox - флажок
    //      photo - загрузка фото
    //      attachment - загрузка файлов
    //      boolean - да/нет
    //      datetime - поле даты
    //      list - список вариантов
    //      information - информация
    //  id - id опции
    //  value - введенное значение опции
    //  items - массив id выбранных вариантов из списка, если опция список
    //  objects - массив id выбранных вариантов из справочника
    // images - массив загруженных изображений в формате base64, если опция это загрузка фото
    // files - массив загруженных файлов, если опция это загрузка файлов
    //  filename - имя файла
    //  data - файл в формате base64
    // wasShowed - (bool) была ли опция показана пользователю - есть опции с условиями, которые выводятся только в том случае, если значение у родительской опции принимает какое-то значение
    postCreateOrder: builder.mutation<BaseResponseType<IServiceOrder>, FormData>({
      query: (data) => ({
        url: `public/service-orders/`,
        method: "POST",
        body: data,
        headers: { "Project-Id": data.get("project_id") },
      }),
    }),
    //получить список заявок
    /*
      isActive - позволяет вернуть заявки в статусах Завершено и Отменено или наоборот - не возвращать такие
    * */
    postServiceOrders: builder.query<
      BaseResponseType<{
        aItems: IServiceOrderShort[]
        bIsEnd: boolean // для пагинации, последние ли данные
        iCount: number
      }>,
      { limit?: number; offset?: number; isActive: boolean; date?: { from: number | null; to: number | null } | null }
    >({
      query: (data) => ({
        url: `public/service-orders/getlist`,
        method: "POST",
        body: data,
      }),
      providesTags: ["Orders"],
    }),
    //получить информацию о заявке
    getServiceOrder: builder.query<IServiceOrderWithReview, { id: string; project_id: string }>({
      query: ({ id, project_id }) => ({
        url: `public/service-orders/${id}`,
        headers: { "Project-Id": project_id },
      }),
      transformResponse: (response: BaseResponseType<IServiceOrderWithReview>) => response.data,
    }),
    getCancelReasons: builder.query<
      { reasons: { id: string; value: string; label: string }[]; require_reason: "select"[] },
      void
    >({
      query: () => ({
        url: "public/service-orders/cancel/reasons",
        method: "GET",
      }),
      transformResponse: (
        response: BaseResponseType<{ reasons: { id: string; name: string }[]; require_reason: "select"[] }>,
      ) => {
        const res = response.data
        const output = res.reasons.map((a) => {
          return { id: a.id, value: a.name, label: a.name }
        })
        return { require_reason: res.require_reason, reasons: output }
      },
    }),
    //отменить заявку
    postCancelOrder: builder.mutation<any, { id: string; reason: string; project_id: string }>({
      query: ({ id, reason, project_id }) => ({
        url: `public/service-orders/cancel/${id}`,
        method: "POST",
        body: { reason: reason },
        headers: { "Project-Id": project_id },
      }),
      invalidatesTags: ["Orders"],
    }),
    returnOrderToWork: builder.mutation<BaseResponseType<any[]>, { id: string; reason: string; project_id: string }>({
      query: ({ id, reason, project_id }) => ({
        url: `public/service-orders/in-work/${id}`,
        method: "POST",
        body: { reason: reason },
        headers: { "Project-Id": project_id },
      }),
    }),
    getQuantityOrderWithoutReview: builder.query<{ count: number }, void>({
      query: () => ({
        url: `public/service-orders/count-orders-without-reviews`,
        method: "GET",
      }),
    }),
    // Количество непрочитанных сообщений суммарно (на главной)
    getCountUnreadMessages: builder.query<{ count: number }, void>({
      query: () => ({
        url: `public/service-orders/count-unread-massages`,
        method: "GET",
      }),
    }),
    postOrderModalWasOpened: builder.mutation<any, { service_order_id: string; project_id: string }>({
      query: ({ service_order_id, project_id }) => ({
        url: `public/service-orders/${service_order_id}/modal-review-impression`,
        method: "POST",
        headers: { "Project-Id": project_id },
      }),
    }),
    getUsers: builder.query<
      { aUsers: IEmployee[]; bIsEnd: boolean; iCount: number },
      { limit?: number; offset?: number; search?: string; department_id: string | null } | void
    >({
      query: (data) => {
        let queryString = ""

        if (data) {
          for (const key in data) {
            if (!queryString) queryString = "?"
            if (queryString && queryString !== "?") queryString = queryString + "&"
            // @ts-ignore
            queryString = queryString + `${key}=${data[key]}`
          }
        }

        return {
          url: `public/user${queryString}`,
          method: "GET",
        }
      },
    }),
    getUsersByProjects: builder.query<
      {
        bIsEnd: boolean
        data: {
          project_id: string
          project_name: string
          users: IEmployee[]
        }[]
        iCount: number
      },
      { limit?: number; offset?: number; search?: string } | void
    >({
      query: (data) => {
        let queryString = ""

        if (data) {
          for (const key in data) {
            if (!queryString) queryString = "?"
            if (queryString && queryString !== "?") queryString = queryString + "&"
            // @ts-ignore
            queryString = queryString + `${key}=${data[key]}`
          }
        }

        return {
          url: `public/user/by-projects${queryString}`,
          method: "GET",
        }
      },
    }),
    getDirectory: builder.query<
      { aObjects: IEmployee[]; bIsEnd: boolean; iCount: number },
      {
        type: TDirectory
        limit?: number
        offset?: number
        search?: string
        optionId?: string
        project_id: string
        signal?: any
      }
    >({
      query: (data) => {
        let queryString = ""

        if (data) {
          for (const key in data) {
            if (!queryString) queryString = "?"
            if (key === "project_id" || key === "signal") continue
            if (queryString && queryString !== "?") queryString = queryString + "&"
            if (queryString && key === "optionId") {
              queryString = queryString + `&option_id=${data?.optionId}`
            } else if (!queryString && key === "optionId") {
              queryString = `?&option_id=${data?.optionId}`
            } else {
              // @ts-ignore
              queryString = queryString + `${key}=${data[key]}`
            }
          }
        }

        return {
          url: `public/service-orders/directory/${data.type}${queryString}`,
          method: "GET",
          headers: { "Project-Id": data?.project_id },
          signal: data?.signal,
        }
      },
      transformResponse: (response: BaseResponseType<{ aObjects: IEmployee[]; bIsEnd: boolean; iCount: number }>) =>
        response.data,
    }),
    getIssuedEquipment: builder.query<
      BaseResponseType<{
        aItems: IEquipment[]
        bIsEnd: boolean
        iCount: number
      }>,
      { status: "planed" | "provided" | "returned"; limit?: number; offset?: number }
    >({
      query: (data) => {
        let queryString = ""

        if (data) {
          for (const key in data) {
            if (!queryString) queryString = "?"
            if (queryString && queryString !== "?") queryString = queryString + "&"
            // @ts-ignore
            queryString = queryString + `${key}=${data[key]}`
          }
        }
        return {
          url: `public/technical-object/hold-list/${queryString}`,
          method: "GET",
        }
      },
    }),
    // Загрузка фотографий
    postLoadPhoto: builder.mutation<{ photoId: string; previewId: null | string }, { name: string; file: any }>({
      query: (data) => ({
        url: `public/photo`,
        method: "POST",
        body: data,
      }),
    }),
    // Получение черновика заявки
    getDraftOrder: builder.mutation<any, { id: string; technical_object_id?: string; project_id: string }>({
      query: ({ id, technical_object_id, project_id }) => ({
        url: `public/services/drafts/${id}?technical_object_id=${technical_object_id}`,
        method: "GET",
        headers: { "Project-Id": project_id },
      }),
    }),
    // Сохранение черновика заявки
    setDraftOrder: builder.mutation<any, { id: string; data: any; project_id: string }>({
      query: ({ id, data, project_id }) => ({
        url: `public/services/drafts/${id}`,
        method: "POST",
        body: data,
        headers: { "Project-Id": project_id },
      }),
    }),
    // Удаление черновика заявки
    deleteDraftOrder: builder.mutation<any, { id: string; technical_object_id?: string; project_id: string }>({
      query: ({ id, technical_object_id, project_id }) => ({
        url: `public/services/drafts/${id}?technical_object_id=${technical_object_id}`,
        method: "DELETE",
        headers: { "Project-Id": project_id },
      }),
    }),
    pdfCheckReq: builder.mutation<any, { id: string; project_id: string }>({
      query: ({ id, project_id }) => ({
        url: `public/service-orders/pdf/check/${id}`,
        method: "POST",
        headers: { "Project-Id": project_id },
      }),
    }),
    pdfCreateReq: builder.mutation<any, { id: string; project_id: string }>({
      query: ({ id, project_id }) => ({
        url: `public/service-orders/pdf/create/${id}`,
        method: "POST",
        headers: { "Project-Id": project_id },
      }),
    }),
    // Старт сканирования qr микромаркетов
    microQRscanStart: builder.mutation<void, string>({
      query: (id) => ({
        url: `public/technical-object/status/serving/${id}`,
        method: "POST",
      }),
    }),
    // Финиш сканирования qr микромаркетов
    microQRscanEnd: builder.mutation<void, string>({
      query: (id) => ({
        url: `public/technical-object/status/served/${id}`,
        method: "POST",
      }),
    }),
    getUnitedCounts: builder.query<
      {
        activeApprovals: number
        isArticlesExists: boolean
        isTechnicalObjectExists: boolean
        ordersWithoutReviews: number
        unreadMassages: number
      },
      void
    >({
      query: () => ({
        url: "public/user/united-counts",
        method: "GET",
      }),
      providesTags: ["UnitedCounts"],
    }),
  }),
  overrideExisting: false,
})

export const {
  usePostCreateOrderMutation,
  usePostServiceOrdersQuery,
  useLazyPostServiceOrdersQuery,
  useGetServiceOrderQuery,
  useLazyGetServiceOrderQuery,
  usePostCancelOrderMutation,
  useReturnOrderToWorkMutation,
  useLazyGetQuantityOrderWithoutReviewQuery,
  useLazyGetCountUnreadMessagesQuery,
  usePostOrderModalWasOpenedMutation,
  useGetUsersQuery,
  useLazyGetUsersQuery,
  useLazyGetUsersByProjectsQuery,
  useLazyGetDirectoryQuery,
  useLazyGetIssuedEquipmentQuery,
  usePostLoadPhotoMutation,
  useGetDraftOrderMutation,
  useSetDraftOrderMutation,
  useDeleteDraftOrderMutation,
  usePdfCheckReqMutation,
  usePdfCreateReqMutation,
  useMicroQRscanStartMutation,
  useMicroQRscanEndMutation,
  useGetUnitedCountsQuery,
  useGetCancelReasonsQuery,
} = contentApi
